/**
 * @description
 * Objeto operations
 */

export class Operations {
    public id:number = null;
    public code:string;
    public type:string;
    public description:string;
    public humanCode:number = null;

    constructor() {}
  
}